
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/cancellation",
      function () {
        return require("private-next-pages/terms/cancellation.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/cancellation"])
      });
    }
  